import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConditionsUtilsService {

  constructor() { }

  /**
   * Cette méthode de savoir si la valeur est 0 ou plus.
   * Si undefined ou null, retourne false.
   * Si 0 ou plus, retourne true.
   */
  public static isZeroOrHigher(value: number): boolean {
    if (value !== undefined && value !== null && (value === 0 || value >= 0)) {
      return true;
    }

    return false;
  }
}
